import { useState } from 'react';
import { RequestFailed } from '../api/client';
import { useApp } from '../state/AppState';
import { PasswordField } from './PasswordField';
import { forgetSessionEnd, lastSessionEnd } from '../api/sessionEnd';

export function LoginScreen() {
  const { login } = useApp();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  // Читаем один раз при открытии: после успешного входа запись уже не нужна
  const [sessionEnd] = useState(lastSessionEnd);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
      forgetSessionEnd();
    } catch (e) {
      setError(e instanceof RequestFailed ? e.error.message : 'Не удалось соединиться с сервером');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="centered">
      <form className="card" onSubmit={submit}>
        <h1>Поговорим</h1>
        <p className="sub">Вход для своих</p>

        <div className="field">
          <label htmlFor="username">Логин</label>
          <input
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            required
          />
        </div>

        <PasswordField
          id="password"
          label="Пароль"
          value={password}
          onChange={setPassword}
          autoComplete="current-password"
        />

        <button type="submit" disabled={busy || !username || !password}>
          {busy ? 'Входим…' : 'Войти'}
        </button>

        {error && <p className="error">{error}</p>}

        {/*
          Почему закончился прошлый сеанс. Жалоба «меня выкинуло» снаружи
          неотличима от «я сам вышел»: экран один и тот же. Здесь видно, что
          именно произошло и когда, — без этого причину приходилось искать
          по журналам сервера, где её и не было.
        */}
        {sessionEnd && (
          <p className="sub" style={{ marginTop: 14, marginBottom: 0 }}>
            Прошлый сеанс завершён: {sessionEnd.reason},{' '}
            {new Date(sessionEnd.at).toLocaleString('ru-RU', {
              day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit',
            })}
          </p>
        )}

        <p className="sub" style={{ marginTop: 18, marginBottom: 0 }}>
          Регистрация только по приглашению. Если вас пригласили — откройте
          присланную ссылку.
        </p>
        {/* Восстановления «самому» нет: почты мы не собираем. Честно говорим,
            что делать, вместо кнопки, которая никуда не ведёт */}
        <p className="sub" style={{ marginTop: 8, marginBottom: 0 }}>
          Забыли пароль? Попросите администратора прислать ссылку на смену.
        </p>
      </form>
    </div>
  );
}
